module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown",
    on: {
      "mouseenter": _vm.clearNewsNotifications
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bell-o",
    staticStyle: {
      "font-size": "1.6rem"
    }
  }), _vm._v(" "), (_vm.newNotification > 0) ? _c('span', {
    staticClass: "bell-badge"
  }, [_vm._v(" " + _vm._s(_vm.newNotification))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    ref: "dropdown",
    staticClass: "dropdown-menu",
    style: (Object.assign({}, (_vm.hasNotifications) ? {
        width: '30em'
      } : {},
      (_vm.notifications.length >= 3) ? {
        height: _vm.screeAvailHeight + 'px'
      } : {},
      {'overflow-y': (_vm.notifications.length >= 3) ? 'scroll' : 'hidden'}))
  }, [(!_vm.hasNotifications) ? _c('li', {
    staticClass: "dropdown-header"
  }, [_vm._v(" \n        Nenhuma notificação recebida no momento\n      ")]) : _c('li', {
    staticClass: "dropdown-header"
  }, [_vm._v(" \n        Notificações gerais\n      ")]), _vm._v(" "), _vm._l((_vm.notifications), function(notification, i) {
    return [(_vm.notifications.length > 0 && notification.typeAlert === 'balance_alert') ? _c('base-notifications', {
      key: i,
      attrs: {
        "fa_icon": "fa-3x fa-dollar"
      }
    }, [_c('BalanceAlertNotification', {
      key: i,
      attrs: {
        "alert": notification
      },
      on: {
        "decreaseNotification": _vm.decreaseNotification
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0 && notification.typeAlert === 'paid_pix') ? _c('base-notifications', {
      key: i,
      attrs: {
        "fa_icon": "fa-3x fa-dollar"
      }
    }, [_c('PixNotification', {
      key: i,
      attrs: {
        "pix": notification
      },
      on: {
        "decreaseNotification": _vm.decreaseNotification
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0 && notification.typeAlert === 'alert-panel') ? _c('base-notifications', {
      key: i,
      attrs: {
        "fa_icon": "fa-2x fa-warning"
      }
    }, [_c('alert-panel-notification', {
      attrs: {
        "alert": notification
      },
      on: {
        "decreaseNotification": _vm.decreaseNotification
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0 &&
      (notification.typeAlert === 'certificate-received' || notification.typeAlert === 'certificate-creation-failed')) ? _c('base-notifications', {
      key: i,
      attrs: {
        "fa_icon": "fa-3x fa-file-code-o"
      }
    }, [_c('certificate-ready-notification', {
      attrs: {
        "certificate": notification
      },
      on: {
        "decreaseNotification": _vm.decreaseNotification
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0 &&
      notification.typeAlert === 'client_added' || notification.typeAlert === 'status_changed') ? _c('base-notifications', {
      key: i,
      attrs: {
        "fa_icon": "fa-2x fa-users"
      }
    }, [_c('notify-user-on-client', {
      attrs: {
        "notifyUser": notification
      },
      on: {
        "decreaseNotification": _vm.decreaseNotification
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0 &&
      notification.typeAlert === 'notify_boleto_payment') ? _c('base-notifications', {
      key: i,
      attrs: {
        "fa_icon": "fa-2x fa-money"
      }
    }, [_c('notify-boleto-payment', {
      attrs: {
        "notify": notification
      },
      on: {
        "decreaseNotification": _vm.decreaseNotification
      }
    })], 1) : _vm._e()]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b55c9b82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/itens_menu/GeneralNotifications.vue
// module id = 852
// module chunks = 2